//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeRegister,
  postJwtRegister,
} from "../../../helpers/fakebackend_helper";

// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  // apiErrorChange
} from "./reducer";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCheckUsername, getOtpCoderReSend, getOtpCodeSend, getOtpCodeVerify } from "helpers/backend_helper";
import { toast } from "react-toastify";
import { savePhoneNumber } from "slices/thunks";
import { Environment } from "environment";

// initialize relavant method of both Auth
const fireBaseBackend: any = getFirebaseBackend();

// Is user register successfull then direct plot user in redux.
export const registerUser = (user: any) => async (dispatch: any) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      response = fireBaseBackend.registerUser(user.email, user.password);
      // yield put(registerUserSuccessful(response));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = postJwtRegister('/post-jwt-register', user);
      // yield put(registerUserSuccessful(response));
    } else if (Environment.apiUrl) {
      response = postFakeRegister(user);
      const data: any = await response;

      if (data.message === "success") {
        dispatch(registerUserSuccessful(data));
      } else {
        dispatch(registerUserFailed(data));
      }
    }
  } catch (error) {
    dispatch(registerUserFailed(error));
  }
};

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

export const checkUser = createAsyncThunk(
  'auth/checkuser',
  async ({ username }: { username: any }, { rejectWithValue }) => {
    try {
      const response: any = await getCheckUsername(username);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const sendOtpCode = createAsyncThunk(
  'otp/sendOtpCode',
  async (
    { type, phoneNumber, email , isVOTP }: { type: "sms"; phoneNumber: string; email: string , isVOTP : boolean },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await getOtpCodeSend(type, phoneNumber, email , isVOTP);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const verifyOtpCode = createAsyncThunk(
  'otp/verifyOtpCode',
  async (
    { code, id }: {  code: string; id: any },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await getOtpCodeVerify(code, id,);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const resendOtpCode = createAsyncThunk(
  'otp/reSendOtpCode',
  async (
    { id , isVOTP }: {   id: string  , isVOTP : boolean},
    { rejectWithValue }
  ) => {
    try {
      const response: any = await getOtpCoderReSend( id , isVOTP);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

// export const apiError = () => {
//   try {
//     const response = apiErrorChange();
//     return response;
//   } catch (error) {
//     return error;
//   }
// };